export default __webpack_public_path__ + "static/media/no-events.74895d31.svg";